import { render, staticRenderFns } from "./SuperconductivityViz.vue?vue&type=template&id=1595d2ca&scoped=true"
import script from "./SuperconductivityViz.vue?vue&type=script&lang=js"
export * from "./SuperconductivityViz.vue?vue&type=script&lang=js"
import style0 from "./SuperconductivityViz.vue?vue&type=style&index=0&id=1595d2ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1595d2ca",
  null
  
)

export default component.exports